import actions from './stockview-listings.actions'
import getters from './stockview-listings.getters'
import mutations from './stockview-listings.mutations'
import state from './stockview-listings.state'

export default {
  namespaced: true,
  state: state(),
  getters,
  mutations,
  actions
}
